import type { PropertySearchQuery } from 'components/marketplace/helpers/useSearchQueries';

import type { StatusTagVariant } from './StatusTag';

/** A status pill in More Filters. */
export type MapStatusFilter = Exclude<StatusTagVariant, 'trending'>;

type StatusFilterQuery = Pick<
  PropertySearchQuery,
  'availableSoon' | 'includeAvailableSoon' | 'includePending' | 'newlyListed' | 'priceDrop'
>;

/** Which status pills a search has on. */
export const statusFiltersFromQuery = (
  query: StatusFilterQuery,
): Record<MapStatusFilter, boolean> => ({
  pendingSale: Boolean(query.includePending),
  newlyListed: Boolean(query.newlyListed),
  priceDrop: Boolean(query.priceDrop),
  comingSoon: Boolean(query.availableSoon),
});

/*
 * The pills select one union of homes. Newly listed and Price drop narrow the
 * homes on the market to those with either status. Coming soon adds the homes
 * available soon, and removes the homes on the market when neither of those
 * pills is on. Pending sale adds homes under contract. An off pill leaves its
 * search field empty.
 */
const STATUS_FILTER_CHANGES: Record<MapStatusFilter, (on: boolean) => StatusFilterQuery> = {
  comingSoon: (on) => ({ availableSoon: on, includeAvailableSoon: false }),
  pendingSale: (on) => ({ includePending: on || null }),
  newlyListed: (on) => ({ newlyListed: on || null }),
  priceDrop: (on) => ({ priceDrop: on || null }),
};

/** The search change that turning a status pill on or off makes. */
export const statusFilterChange = (status: MapStatusFilter, on: boolean): StatusFilterQuery =>
  STATUS_FILTER_CHANGES[status](on);
